var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#D85263"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20112 8.01676L6.03352 3H8.26816L8.10056 8.01676H6.20112ZM7.15084 11C6.83799 11 6.56611 10.8883 6.3352 10.6648C6.11173 10.4339 6 10.162 6 9.84916C6 9.53631 6.11173 9.26816 6.3352 9.04469C6.56611 8.81378 6.83799 8.69832 7.15084 8.69832C7.46369 8.69832 7.73184 8.81378 7.95531 9.04469C8.18622 9.26816 8.30168 9.53631 8.30168 9.84916C8.30168 10.162 8.18622 10.4339 7.95531 10.6648C7.73184 10.8883 7.46369 11 7.15084 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/warning-red.99ac78a0c6cbcc1198d82f98a012ed88.svg";
export { ForwardRef as ReactComponent };